import './SupportIcon.scss';

import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { useEvent } from '../../../../data/hooks/eventHooks';
import { useLocale } from '../../../../data/hooks/i18nHooks';
import { useIsDemoMode } from '../../../../data/hooks/ui/useIsDemoMode';

const SupportIcon = (props) => {
    const { style } = props,
        locale = useLocale(),
        { eventId } = props,
        event = useEvent(eventId),
        isDemo = useIsDemoMode();

    if (isDemo) return null;

    return (
        <a
            className="SupportIcon VerticalCenter text-center"
            href={`https://networkapp.com/${locale}/support/`}
            style={
                style || {
                    color: event?.settings?.primary_color,
                }
            }
            target="_blank">
            ?
        </a>
    );
};

export default (props) => (
    <Switch>
        <Route path="/events/:eventId">
            <SupportIcon {...props} />
        </Route>
        <SupportIcon {...props} />
    </Switch>
);
